export default __webpack_public_path__ + "static/soda4-15321161a63828a44d23e8b29233eca5.png";